import { Roles } from "@/models/user.model";
import { getUserFromStorage } from "@/utils/user-store.util";

export function guardStudent(to: any, from: any, next: any) {
  if (getUserFromStorage()?.role == Roles.STUDENT) {
    next();
  } else {
    next("/sign-in");
  }
}
